import * as React from "react";
import "./styles.scss";
import ProductAccordion from "../ProductAccordion/ProductAccordion";
import fetch from "node-fetch";
import { useEffect, useState } from "react";
import { getQueryParams } from "../../lib/Misc";
import ProductImageCarousel from "../ProductAccordion/content/ProductImageCarousel";
import PPDetailsMoreBlock from "./PPDetailsMoreBlock";
import ProductTabulate from "../ProductTabulate/ProductTabulate";

const shopTheCollectionLink =
  "https://www.chintiandparker.com/?dwg=CjwKCAjw_KjVBhAHEiwAnC0N9JWhAYM9pAEw6x32gxzn8W%02gV_l9RJVNT_OD81q8l9XNFujMgmKfNBoCuhsQAvD_BwE&tw_source=google&tw_adid=801302487536&tw_campaign=17961783966&tw_kwdid=kwd%02320161720772&gad_source=1&gad_campaignid=17961783966&gbraid=0AAAAADs9ezgvP%02iHOBQvjn1rhqp_HqJI0&gclid=CjwKCAjw_KjVBhAHEiwAnC0N9JWhAYM9pAEw6x32gxzn8W-gV_l9RJVNT_OD81q8l9XNFujMgmKfNBoCuhsQAvD_BwE";

export default function ProductPassport({ passportID, passportKey }) {
  const [productPassportDataCarousel, setProductPassportDataCarousel] =
    useState([]);
  const [productPassportDataHead, setProductPassportDataHead] = useState([]);
  const [mainImageLoaded, setMainImageLoaded] = useState(false);
  const [productLoaded, setProductLoaded] = useState(true);

  const fetchProductData = () => {
    let queryParams = getQueryParams();
    queryParams =
      queryParams && queryParams.code
        ? queryParams
        : JSON.parse(localStorage.getItem("queryParams"));

    if (passportKey || (queryParams && queryParams.code)) {
      let requestUrlSuffix =
        passportID === "xelakey"
          ? passportKey
          : passportKey
          ? `gtin/${passportKey}`
          : `cpa${queryParams.code}`;

      fetch(
        `${
          process.env.GATSBY_FABACUS_API_URL ||
          "https://api.testing.xela.co/v1/"
        }product/${requestUrlSuffix}`
      )
        .then((response) => response.json()) // parse JSON from request
        .then((resultData) => {
          if (resultData && Array.isArray(resultData)) {
            setProductLoaded(true);
            setProductPassportDataCarousel(
              resultData.filter((item) => item.type === "collapsable")
            );
            setProductPassportDataHead(
              resultData.filter((item) => item.type === "information")
            );

            imageIsLoaded("main_image");
          }
          if (resultData && resultData.problem) {
            setProductLoaded(false);
            setProductPassportDataHead(resultData?.problem);
          }
        });
    } else {
      setProductLoaded(false);
    }
  };

  useEffect(() => {
    if (
      !productPassportDataCarousel ||
      productPassportDataCarousel.length === 0
    ) {
      fetchProductData();
    }
  }, []);

  const imageIsLoaded = (image_id) => {
    const image = document.getElementById(image_id);
    const isLoaded = image && image.complete && image.naturalHeight !== 0;
    if (isLoaded) {
      setMainImageLoaded(true);
      return true;
    } else {
      setTimeout(() => {
        imageIsLoaded(image_id);
      }, 333);
    }
  };

  return (
    <div className={`block product-passport`}>
      {productLoaded ? (
        <>
          <div className={`product-passport-top-display`}>
            <div className={`image-bg`}>
              {productPassportDataHead[0] &&
                productPassportDataHead[0].image_carousel &&
                productPassportDataHead[0].image_carousel.length > 0 && (
                  <ProductImageCarousel
                    productImageList={productPassportDataHead[0].image_carousel}
                  />
                )}
            </div>
          </div>

          <div className={`product-passport-info-display`}>
            {productPassportDataHead[0] &&
              productPassportDataHead[0].product_icons && (
                <ProductTabulate
                  tabListDataIcons={productPassportDataHead[0].product_icons}
                  tabListData={productPassportDataHead[0].product_icons_data}
                />
              )}

            <div className="product-passport-head">
              {productPassportDataHead.map((headItem, index) => (
                <div key={"head-item" + index} className="head-item">
                  <h2>{headItem.title}</h2>
                  {headItem.composition && (
                    <h4>
                      <b>Composition:</b> <span>{headItem.composition}</span>
                    </h4>
                  )}
                  <PPDetailsMoreBlock headItem={headItem} />
                </div>
              ))}
              <div
                onClick={() => window.open(shopTheCollectionLink, "_blank")}
                style={{
                  width: "fit-content",
                  backgroundColor: "black",
                  borderRadius: 4,
                  padding: "10px 34px",
                  color: "white",
                  fontSize: 18,
                  fontFamily: "Futura PT",
                  cursor: "pointer",
                  margin: "24px auto 0",
                }}
              >
                Shop The Collection
              </div>
            </div>

            <ProductAccordion data={productPassportDataCarousel} />

            <div
              className="scroll-top-element"
              onClick={() => {
                window[`scrollTo`]({ top: 0, behavior: `smooth` });
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 50 50"
              >
                <g data-name="Group 924" transform="translate(-362 -860)">
                  <circle
                    data-name="Ellipse 18"
                    cx="25"
                    cy="25"
                    r="25"
                    transform="translate(362 860)"
                  />
                  <g data-name="right-arrow (1)">
                    <g data-name="Group 923">
                      <path
                        data-name="Path 1277"
                        d="m386.804 877.246-5.558 5.559a.845.845 0 0 0 0 1.191l.5.5a.836.836 0 0 0 .6.246.853.853 0 0 0 .6-.246l3.25-3.243v10.307a.822.822 0 0 0 .831.832h.714a.854.854 0 0 0 .865-.832v-10.339l3.268 3.28a.834.834 0 0 0 1.183 0l.5-.5a.845.845 0 0 0 0-1.191l-5.559-5.559a.85.85 0 0 0-1.2 0z"
                      />
                    </g>
                  </g>
                </g>
              </svg>
            </div>
          </div>
        </>
      ) : !!productPassportDataHead?.product ? (
        <div className={`sorry-message-wrapper`}>
          <p className="title">
            Your Digital Product Passport is still in transit
          </p>
          <p className="description">
            Check back soon to trace the journey this garment has been on from
            fabric to factory.
          </p>
          <p>
            {productPassportDataHead?.product?.sku} |{" "}
            {productPassportDataHead?.product?.size}
          </p>
        </div>
      ) : (
        <div className={`sorry-message-wrapper`}>
          <p className="title">Scan the QR code on the care label</p>
          <p className="description">for your product passport</p>
        </div>
      )}
    </div>
  );
}
